module.exports = __webpack_public_path__ + "img/brand-logo.cf0d42fa.png";